import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";

const perPage = 20;

interface FreeFieldProfileListProps extends MultiPickerListProps<server.dto.FreeFieldProfileSmall> {
  environment: server.dto.Environments;
}

const MultiFreeFieldProfileList = (props: FreeFieldProfileListProps) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListFreeFieldProfileInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
    environment: props.environment,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={newInstruction => setInstruction({ ...newInstruction, environment: props.environment })}
    queryKey="listFreefieldProfile"
    api={window.CoreApi.FreeFieldProfile.PaginatedSmall}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={ff => <>
      <div>{ff.title}</div>
    </>}
    getId={freefieldprofile => freefieldprofile.freeFieldProfileId}
    getLabel={freefieldprofile => < div > {freefieldprofile.title}</div >}
    value={props.value}
  />
};

export default MultiFreeFieldProfileList;